import posthog from "@/lib/posthog-client";
import { getConsoleLogRecord } from "@/lib/posthog-log-safety";

const originalConsole = {
  error: console.error.bind(console),
  warn: console.warn.bind(console),
};

let isInstalled = false;

export function installBrowserPostHogLogging() {
  if (isInstalled) {
    return;
  }

  isInstalled = true;

  console.warn = (...args: unknown[]) => {
    originalConsole.warn(...args);
    if (process.env.NODE_ENV === "production") {
      posthog.captureLog({ ...getConsoleLogRecord("warn", args), level: "warn" });
    }
  };
  console.error = (...args: unknown[]) => {
    originalConsole.error(...args);
    if (process.env.NODE_ENV === "production") {
      posthog.captureLog({
        ...getConsoleLogRecord("error", args),
        level: "error",
      });
    }
  };
}
